import React, { useState } from "react";
import {
  Card,
  CardContent,
  Button,
  makeStyles,
  FormControl,
  InputLabel,
  Input,
  InputAdornment,
  IconButton,
  CircularProgress,
  CardMedia,
  OutlinedInput,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import {
  displaySnackbar,
  SetUserAccess,
  switchThemeDefault,
} from "../../actions/index";
import { useHistory } from "react-router-dom";
import { useContext } from "react";
import { Particles } from "react-particles-js";
import jetPressLogo from "../../assets/images/min-wordpress-logo.png";
import BrandLogo from "../../assets/images/jetpress-logo-white.svg";
import BrandLogoLight from "../../assets/images/jetpress-logo-dark.svg";
import { MasterContext } from "../../context/master";
import { useTranslation } from "react-i18next";
import { useTheme } from "@material-ui/styles";
import { useEffect } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useMediaPredicate } from "react-media-hook";
import { ChangeLanguage } from "../../actions";
import {
  LANG_TURKISH,
  LANG_DEUTSCH,
  LANG_ENGLISH,
} from "../../constants/language";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    textAlign: "-webkit-center",
    alignItems: "center",
    background: "#006EFF",
    background:
      theme.palette.type === "light" ? "rgb(0,110,255)" : "rgb(68,68,68)",
    background:
      theme.palette.type === "light"
        ? "-moz-linear-gradient(45deg, rgba(0,110,255,1) 0%, rgba(0,55,128,1) 100%)"
        : "-moz-linear-gradient(45deg, rgba(68,68,68,1) 0%, rgba(18,18,18,1) 100%)",
    background:
      theme.palette.type === "light"
        ? "-webkit-linear-gradient(45deg, rgba(0,110,255,1) 0%, rgba(0,55,128,1) 100%)"
        : "-webkit-linear-gradient(45deg, rgba(68,68,68,1) 0%, rgba(18,18,18,1) 100%)",
    background:
      theme.palette.type === "light"
        ? "linear-gradient(45deg, rgba(0,110,255,1) 0%, rgba(0,55,128,1) 100%)"
        : "linear-gradient(45deg, rgba(68,68,68,1) 0%, rgba(18,18,18,1) 100%)",
    filter:
      theme.palette.type === "light"
        ? "progid: DXImageTransform.Microsoft.gradient(startColorstr='#006eff',endColorstr='#003780',GradientType=1)"
        : "progid:DXImageTransform.Microsoft.gradient(startColorstr='#444444',endColorstr='#121212',GradientType=1)",
  },
  formCard: {
    zIndex: 2000,
    [theme.breakpoints.down("sm")]: {
      width: "300px",
    },
    width: "480px",
  },
  media: {
    height: 0,
    padding: 40,
    marginTop: 40,
    backgroundSize: "contain",
  },
  formElement: {
    marginTop: theme.spacing(1),
  },
  submitButton: {
    marginTop: theme.spacing(3),
  },
  particle: {
    position: "absolute",
    top: 0,
    left: 0,
    height: "100%",
    width: "100%",
  },
  inputAdornmentStyle: {
    paddingLeft: 8,
    marginTop: -5,
    "&shrink": {
      paddingTop: 8,
    },
  },
}));

const LoginPage = (props) => {
  const [accountName, setAccountName] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const context = useContext(MasterContext);
  const theme = useTheme();
  const isDark = theme.palette.type === "dark" ? true : false;
  const classes = useStyles();
  const recaptchaRef = React.createRef();
  const [captchaValue, setCaptchaValue] = useState("");
  const preferredTheme = useMediaPredicate("(prefers-color-scheme: dark)")
    ? "dark"
    : "light";

  const onChange = (value) => {
    setCaptchaValue(value);
  };

  /*const handleSubmit = (e) => {
    e.preventDefault();
    if (captchaValue === "") {
    } else {
      e.preventDefault();
      setLoading(true);
      context
        .Login(accountName, password)
        .then((response) => {
          dispatch(
            SetUserAccess(
              response.data.access_token,
              response.data.userName,
              response.data.role,
              response.data.customer_id,
              response.data.access_id,
              Date.now()
            )
          );
          history.push("/my-websites");
        })
        .catch((error) => setLoading(false));
    }
  };*/

  const handleSubmit = (e) => {
    e.preventDefault();
    if (captchaValue) {
      recaptchaRef.current.reset();
    }

    recaptchaRef.current.execute();
  };

  useEffect(() => {
    if (captchaValue) {
      setLoading(true);
      context
        .Login(accountName, password)
        .then((response) => {
          dispatch(
            SetUserAccess(
              response.data.access_token,
              response.data.userName,
              response.data.role,
              response.data.customer_id,
              response.data.access_id,
              Date.now()
            )
          );

          if (response.data.setting_ui) {
            if (JSON.parse(response.data.setting_ui).theme.includes("light")) {
              dispatch(switchThemeDefault("light"));
            } else {
              dispatch(switchThemeDefault("dark"));
            }
            if (
              JSON.parse(
                JSON.parse(response.data.setting_ui).language
              ).Current.includes("tr")
            ) {
              dispatch(ChangeLanguage(LANG_TURKISH));
            } else {
              dispatch(ChangeLanguage(LANG_ENGLISH));
            }

            history.push("/my-websites");
          } else {
            dispatch(switchThemeDefault(preferredTheme));
            history.push("/my-websites");
          }
        })

        .catch((error) => setLoading(false));
    }
  }, [captchaValue]);
  useEffect(() => {
    setAccountName(accountName.replace(/\s+/g, ""));
    setPassword(password.replace(/\s+/g, ""));
  }, [accountName, password]);
  return (
    <div className={classes.root}>
      <Card className={classes.formCard}>
        <CardMedia
          className={classes.media}
          image={isDark ? BrandLogo : BrandLogoLight}
        ></CardMedia>
        <CardContent style={{ padding: 40 }}>
          <form onSubmit={handleSubmit}>
            <FormControl fullWidth variant="standard">
              <InputLabel className={classes.inputAdornmentStyle}>
                {t("E-Mail / Account-ID")}
              </InputLabel>
              <OutlinedInput
                autoFocus={true}
                value={accountName}
                onChange={(event) => setAccountName(event.target.value)}
                color="primary"
                aria-label={t("E-Mail / Account-ID")}
              ></OutlinedInput>
            </FormControl>
            <FormControl className={classes.formElement} fullWidth>
              <InputLabel className={classes.inputAdornmentStyle}>
                {t("Password")}
              </InputLabel>
              <OutlinedInput
                endAdornment={
                  <InputAdornment on="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                fullWidth
                aria-label="Password"
              ></OutlinedInput>
            </FormControl>
            <Button
              type="submit"
              disabled={!accountName || !password || loading}
              fullWidth
              size={"large"}
              variant="contained"
              color="primary"
              className={classes.submitButton}
            >
              {loading ? <CircularProgress size={24} /> : t("LOG IN")}
            </Button>
            <ReCAPTCHA
              ref={recaptchaRef}
              size="invisible"
              sitekey="6LdensYZAAAAAJkB_kDwly7Yej7lUjxxsvosNlpL"
              onChange={onChange}
            />
          </form>
        </CardContent>
      </Card>
      <Particles
        className={classes.particle}
        params={{
          fps_limit: 60,
          particles: {
            number: {
              value: 80,
              density: {
                enable: true,
                value_area: 800,
              },
            },
            color: {
              value: "#FFFFFF",
            },
            shape: {
              type: "circle",
              stroke: {
                width: 0,
                color: "#000000",
                opacity: 0.2,
              },
              polygon: {
                nb_sides: 5,
              },
              image: {
                src: "img/github.svg",
                width: 100,
                height: 100,
              },
            },
            opacity: {
              value: 0.3,
              random: false,
              anim: {
                enable: false,
                speed: 1,
                opacity_min: 0.1,
                sync: false,
              },
            },
            size: {
              value: 3,
              random: true,
              anim: {
                enable: false,
                speed: 40,
                size_min: 0.1,
                sync: false,
              },
            },
            line_linked: {
              enable: true,
              distance: 150,
              color: "#FFFFFF",
              opacity: 0.2,
              width: 1,
            },
            move: {
              enable: true,
              speed: 6,
              direction: "none",
              random: false,
              straight: false,
              out_mode: "out",
              bounce: false,
              attract: {
                enable: false,
                rotateX: 600,
                rotateY: 1200,
              },
            },
          },
          interactivity: {
            detect_on: "canvas",
            events: {
              onhover: {
                enable: false,
                mode: "repulse",
              },
              onclick: {
                enable: false,
                mode: "push",
              },
              resize: true,
            },
            modes: {
              grab: {
                distance: 400,
                line_linked: {
                  opacity: 1,
                },
              },
              bubble: {
                distance: 400,
                size: 40,
                duration: 2,
                opacity: 8,
                speed: 3,
              },
              repulse: {
                distance: 200,
                duration: 0.4,
              },
              push: {
                particles_nb: 4,
              },
              remove: {
                particles_nb: 2,
              },
            },
          },
          retina_detect: true,
        }}
      />
    </div>
  );
};

export default LoginPage;
